import { type DefaultConfigOptions, createInput } from '@formkit/vue'
import { dbcText } from './inputs/dbcText'
import { dbcEmail } from './inputs/dbcEmail'
import Autocomplete from './inputs/Autocomplete.vue'
import InputMask from './inputs/InputMask.vue'
import FormPhoneInput from './inputs/FormPhoneInput.vue'
import addAsteriskPlugin from './plugins/addAsteriskPlugin'
import loadingPulsePlugin from './plugins/loadingPulsePlugin'
import floatingLabelsPlugin from './plugins/floatingLabelsPlugin'
import autoHeightTextarea from './plugins/autoHeightTextarea'
import { de, en } from '@formkit/i18n'
import addValidationMessageIcon from './plugins/addValidationMessageIcon'
import Icons from './icons'
import Theme from './theme'

import './plugins/css/floatingLabel.css'
import './plugins/css/loadingPulse.css'

const config: DefaultConfigOptions = {
  inputs: {
    dbcText,
    dbcEmail,
    dbc_autocomplete: createInput(Autocomplete, {
      props: ['options', 'matches', 'selection', 'address'],
    }),
    dbcInputMask: createInput(InputMask),
    dbcTel: createInput(FormPhoneInput, {
      props: ['options'],
    }),
  },
  locale: 'de',
  locales: { de, en },
  plugins: [
    addAsteriskPlugin,
    loadingPulsePlugin,
    addValidationMessageIcon,
    floatingLabelsPlugin,
    autoHeightTextarea,
  ],
  icons: Icons,
  config: {
    classes: Theme,
  },
}

export default config
